<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    count?: number
    class?: string
  }>(),
  {
    count: 9,
    class: '',
  }
)
</script>

<template>
  <div :class="cn('grid grid-cols-3 gap-4', props.class)">
    <div v-for="(_, index) in props.count" :key="index" class="flex flex-col">
      <div class="aspect-square w-full animate-pulse bg-neutral-100"></div>
      <UiSkeletonText class="mt-2 h-5" />
    </div>
  </div>
</template>
